const emissao_da_confirmacao_de_matricula = {
  path: "/emissao-da-confirmacao-de-matricula",
  redirect: "/emissao-da-confirmacao-de-matricula",
  meta: {
    breadCrumb: "Atendimento ao Aluno - Emitir Confirmação de Matrícula",
  },
  children: [
    {
      path: "/emissao-da-confirmacao-de-matricula",
      name: "emissao_da_confirmacao_de_matricula",
      component: () =>
        import(
          "@/views/EmissaoDaConfirmacaoDeMatricula/EmissaoDaConfirmacaoDeMatriculaHome.vue"
        ),
    },
  ],
};

export { emissao_da_confirmacao_de_matricula };
